// Brand assets (uploaded by user)
export const LOGO_URL = 'https://customer-assets-4nw71qhi.emergentagent.net/job_hair-salon-diegem/artifacts/me3x719p_logo1.png';
export const HERO_IMAGE_URL = 'https://static.prod-images.emergentagent.com/jobs/682cdf6f-1540-4652-864e-47d6dad413ec/images/a3850a78a31103f5f479b3a98725960bb67e129ada20b7ccac8c19d8d8bcf505.jpeg';

export const BRAND = {
  green: '#0d3b25',
  greenDark: '#04140e',
  gold: '#c5a059',
  goldBright: '#d4af37',
  cream: '#f5efe1',
  creamLight: '#faf6ec',
};
